
// This is an auto generated file - do not edit!
// Swagger path: /api/AnswerType/{code}/answers

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Answer
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class AnswertypeCodeAnswersApiService extends BaseApiService {
    
    get(code: string, options = {}): Observable<Answer[]> {
        return this._get<Answer[]>(
            `/AnswerType/${code}/answers`,
            options
        );
    }
}
